import React from "react";
import {
  findCompanyByInn,
  resolveManagersForCompany,
} from "../../../utils/reportManagerFilterUtils";

const GRID_CLASS = "cc-v4-soft-grid reports-version-grid";

export function ItemVersionReport({ ver, moveCompany, companys }) {
  const { responsible, support } = resolveManagersForCompany(
    findCompanyByInn(companys, ver.inn),
  );

  return (
    <div
      onClick={() => moveCompany(ver)}
      className={`cc-v4-soft-row ${GRID_CLASS} reports-soft-row`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          moveCompany(ver);
        }
      }}
    >
      <span className="reports-cell">{ver.name_company}</span>
      <span className="reports-cell company-card-v4-mono">{ver.inn}</span>
      <span
        className={`reports-cell${
          responsible.muted ? " reports-cell-muted" : ""
        }`}
      >
        {responsible.text}
      </span>
      <span
        className={`reports-cell${support.muted ? " reports-cell-muted" : ""}`}
      >
        {support.text}
      </span>
      <span className="reports-cell reports-cell-numeric">{ver.count}</span>
    </div>
  );
}

export { GRID_CLASS as VERSION_REPORT_GRID_CLASS };
